var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsteriksPoint2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4863 11.4968L21.7922 14.8237L19.2483 19.1941L12.79 14.5625L13.5732 22.521H8.41968L9.20215 14.5625L2.6792 19.1941L0.135254 14.8237L7.50635 11.4968L0.135254 8.16992L2.6792 3.79907L9.20215 8.43091L8.41968 0.472656H13.5732L12.79 8.43091L19.2483 3.79907L21.7922 8.16992L14.4863 11.4968Z",
    fill: "#1B3764"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsteriksPoint2);
export default __webpack_public_path__ + "static/media/Asteriks_point_2.7be164d7eafd9b7f5472ba592ee44c37.svg";
export { ForwardRef as ReactComponent };